import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import CargoModal from './components/CargoModal';
import EditCargoModal from './components/EditCargoModal';
import AdminDashboard from './AdminDashboard';

const Cargo = () => {
  const [cargoData, setCargoData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedCargo, setSelectedCargo] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const cargoCollectionRef = collection(db, 'cargo');
      const snapshot = await getDocs(cargoCollectionRef);
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setCargoData(data);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const handleAddModalOpen = () => {
    setIsAddModalOpen(true);
  };

  const handleAddModalClose = () => {
    setIsAddModalOpen(false);
  };

  const handleEditModalOpen = (cargo) => {
    setSelectedCargo(cargo);
    setIsEditModalOpen(true);
  };

  const handleEditModalClose = () => {
    setSelectedCargo(null);
    setIsEditModalOpen(false);
  };

  const refreshTable = async () => {
    try {
      const cargoCollectionRef = collection(db, 'cargo');
      const snapshot = await getDocs(cargoCollectionRef);
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setCargoData(data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return (
    <div className="d-flex">
      <AdminDashboard />
      <div className="container mt-5">
        <h2 className="text-2xl font-bold mb-4">Cargo Page</h2>
        <button
          onClick={handleAddModalOpen}
          className="mb-4 btn btn-primary"
        >
          Add New Cargo
        </button>
        {isLoading ? (
          <p>Loading...</p>
        ) : (
          <table className="table table-bordered">
            <thead className="thead-light">
              <tr>
                <th>Tracking ID</th>
                <th>User Name</th>
                <th>From Country</th>
                <th>To Country</th>
                <th>Date</th>
                <th>Last Update</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {cargoData.map((cargo) => (
                <tr key={cargo.id}>
                  <td>{cargo.tracking_id}</td>
                  <td>{cargo.user_name}</td>
                  <td>{cargo.from_country}</td>
                  <td>{cargo.to_country}</td>
                  <td>
                    {cargo.date.toDate().toLocaleDateString()}
                  </td>
                  <td>
                    {cargo.last_update.toDate().toLocaleDateString()}
                  </td>
                  <td>{cargo.status}</td>
                  <td>
                    <button
                      onClick={() => handleEditModalOpen(cargo)}
                      className="btn btn-info"
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <CargoModal isOpen={isAddModalOpen} onClose={handleAddModalClose} refreshTable={refreshTable} />
        {selectedCargo && (
          <EditCargoModal
            isOpen={isEditModalOpen}
            onClose={handleEditModalClose}
            refreshTable={refreshTable}
            initialCargo={selectedCargo}
          />
        )}
      </div>
    </div>
  );
};

export default Cargo;
